import React, { useState, useRef } from 'react'
import Link from 'components/Link'
import InputEmail from 'components/InputEmail'
import Rut from 'components/Forms/Inputs/InputRut'
import Loader from 'components/Loader'
import { cleanSearch } from 'utils/index'
import TagManagerService from 'services/TagManager'
import Newsletters from 'services/Newsletters/'
import PubSub from 'services/PubSub/';
import style from './style.scss'

const SubscribeForm = () => {
    const [formIsValid, setFormIsValid] = useState(false)
    const [rutIsValid, setRutIsValid] = useState(false)
    const [emailIsValid, setEmailValid] = useState(false)
    const [rutValue, setRutValue] = useState('')
    const [isLoading, setLoading] = useState(false)

    const emailInput = useRef(null)
    const checkbox = useRef(null)

    const [mountRut, setMountRut] = useState(true)

    const submitSuscribe = (e) => {
        e.preventDefault()

        if (!formIsValid) {
            if (!emailIsValid) {
                PubSub.dispatch(`forceInputWarning_email`, {})
            } 
            if (!rutIsValid) {
                PubSub.dispatch(`forceInputWarning_rut`, {})
            }
            return
        }

        let email = emailInput.current.value
        let rut = cleanSearch(rutValue.replace(/\s/g, ''))

        setLoading(true)

        Newsletters.suscribeNewsletter(email, rut).then((response) => {
            setMountRut(!mountRut)
            
            setEmailValid(false)
            setRutIsValid(false)
            setFormIsValid(false)
            
            setLoading(false)
            
            emailInput.current.value = ''
            checkbox.current.checked = false

            return response
        })

        TagManagerService.suscribe('Envío solicitud', email)
        
    }

    const validateForm = () => {
        const isvalid = rutIsValid && emailIsValid && checkbox.current.checked
        if (isvalid !== formIsValid) {
            setFormIsValid(isvalid)
        }
    }

    const _getValidMail = (isValid) => {
        setEmailValid(isValid)
    }

    const rutValid = (valid, value) => {
        setRutIsValid(valid)
        setRutValue(value)
    }

    return (
        <form className="subscribe-form">
            <div className="subscribe-form-wrapper">
                <div className="subscribe-form-mail">
                    <InputEmail
                        ref={emailInput}
                        showIcon={false}
                        key="email"
                        className={'subscribe-form-mail-input'}
                        name="email"
                        label=""
                        required={false}
                        placeholder="Mail"
                        value=""
                        type="email"
                        helpText=""
                        size=""
                        message={{ error: 'Mail inválido' }}
                        validateForm={validateForm}
                        aria-label="Mail input"
                        callbackValidate={_getValidMail}
                        
                    />
                </div>

                <div
                    className={'subscribe-form-rut' +(!rutIsValid ? ' container-error' : '')}>
                    <Rut
                        callbackisValid={rutValid}
                        errorMessageValue={'Rut inválido'}
                        key={mountRut}
                    />
                </div>

                <button
                    type="submit"
                    className={`subscribe-form-submit primary-btn`}
                    onClick={submitSuscribe}>
                    {isLoading ? <Loader /> : (<span className="">Enviar</span>)}
                </button>
            </div>

            <label className="subscribe-form-check">
                <input
                    className="subscribe-form-check-input mobile-click"
                    type="checkbox"
                    name="Terms Acceptation"
                    ref={checkbox}
                    onChange={validateForm}
                />
                <span className="subscribe-form-terms-and-conditions">
                    Acepto los{' '}<Link to="/institucional/terminos-condiciones">Términos y Condiciones</Link>
                </span>
            </label>
        </form>
    )
}

export default SubscribeForm
